import styled from "styled-components";
import { Link } from "react-router-dom";
import { colors } from "../../config/constants";

export const ParticipantsWrapper = styled.div`
    min-height: 100vh;
    min-width: 80vw;
    padding: 20px;
    font-family: 'Oswald', sans-serif;
    font-size: 10px;
    @media (min-width: 500px) {
        font-size: 14px;
    }
    @media (min-width: 768px) {
        font-size: 18px;
    }
    > table {
        width: 100%;
        table-layout: fixed;
        th {
            text-align: left;
        }
        .small {
            width: 100px;
        }
    }
    @media (min-width: 768px) {
        max-width: 600px;
    }   
    a {
        text-decoration: none;
        color: ${colors.RuenOrange};
    }
    h2 {
        border: 3px solid ${colors.RuenOrange};
        border-radius: 15px;
        color: black;
        padding: 5px 10px;
        margin: 40px 0 10px;
        width: fit-content;
    }
`;

export const Paid = styled.td<{ paid: boolean }>`
    color: ${props => props.paid ? "green" : ''};
`;

export const TableRow = styled.tr<{ highlighted: boolean }>`
    background-color: ${props => props.highlighted ? colors.RuenOrange : "transparent"};
    color: ${props => props.highlighted ? "white" : colors.OsogovoBlack};
    > td {
        padding: 2px;
    }
    > td:nth-child(1) {
        font-weight: bold;
    }
    > td:nth-child(3) {
        width: 150px;
    }
    a {
        color: inherit;
    }

    &:hover {
        background-color: ${colors.RuenOrange};
        color: white;
        cursor: pointer;
        > td {
            background-color: ${colors.RuenOrange};
            color: white;
        }
        ${Paid} {
            color: white;
        }
    }
`;

export const TableCellLink = styled(Link)`
    display: block;
    color: inherit;
    text-decoration: none;
`;